export default "__VITE_ASSET__783fa535__$_?nuxt_component=async__"